import React, { useState } from 'react';
import { caseStudies } from './CaseStudiesData';
import CaseStudyModal from './CaseStudyModal';
import { motion } from 'framer-motion';

const Projects = () => {
    const [selectedStudy, setSelectedStudy] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleOpenModal = (study) => {
        setSelectedStudy(study);
        setIsModalOpen(true);
    };

    return (
        <div className="w-full mx-auto px-6 lg:px-12 mb-20 text-zinc-800 dark:text-zinc-200 text-sm">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12">
                {caseStudies.map((study) => (
                    <motion.div 
                        key={study.id} 
                        className="flex flex-col justify-between p-5 rounded-3xl border border-slate-200 dark:border-slate-800/80 bg-white dark:bg-[#202222] shadow-sm hover-glow transition-all duration-300 cursor-pointer"
                        onClick={() => handleOpenModal(study)}
                        whileHover={{ y: -4 }}
                    >
                        <div className="space-y-4">
                            <div className="relative aspect-[16/10] w-full rounded-2xl overflow-hidden bg-slate-900 border border-slate-100 dark:border-slate-800/80 flex items-center justify-center">
                                {study.id === "jenga-realty" ? (
                                    <div className="flex space-x-4 p-4 items-center justify-center">
                                        <img src={study.image} alt={study.title} className="h-28 object-contain" />
                                        {study.imageAlt && <img src={study.imageAlt} alt={study.title} className="h-28 object-contain hidden sm:block" />}
                                    </div>
                                ) : (
                                    <img src={study.image} alt={study.title} className="w-full h-full object-cover opacity-80 dark:opacity-75 hover:opacity-100 transition-opacity duration-300" />
                                )}
                            </div>
                            
                            <div className="space-y-2">
                                <span className="inline-block px-2.5 py-0.5 rounded-full text-[10px] font-semibold bg-purple-100 dark:bg-purple-950/40 text-purple-700 dark:text-purple-400 border border-purple-200 dark:border-purple-800/30 uppercase tracking-wider">
                                    {study.category}
                                </span>
                                <h3 className="text-xl font-bold text-zinc-900 dark:text-white">{study.studyName || study.title}</h3>
                                <p className="text-xs text-zinc-500 dark:text-zinc-400 font-light line-clamp-2 leading-relaxed">
                                    {study.subtitle}
                                </p>
                            </div>
                        </div>
                        
                        <div className="pt-4 mt-4 border-t border-slate-100 dark:border-slate-800/60 flex justify-between items-center text-xs font-semibold text-purple-650 dark:text-purple-400 hover:text-purple-750 dark:hover:text-purple-300 transition-colors">
                            <span>Read Case Study</span>
                            <svg xmlns="http://www.w3.org/2050/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2.5} stroke="currentColor" className="w-4 h-4">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
                            </svg>
                        </div>
                    </motion.div>
                ))}
            </div>
            
            <CaseStudyModal 
                isOpen={isModalOpen} 
                onClose={() => setIsModalOpen(false)} 
                study={selectedStudy} 
            />
        </div>
    );
};

export default Projects;